import React, { useState } from "react";
import { TbCaretUpDownFilled } from "react-icons/tb";

function Product_Management_Details() {
  const [openAssignModal, setOpenAssignModal] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  return (
    <>
      <style>
        {`
          .custom-select {
            appearance: none; 
            -webkit-appearance: none;
            -moz-appearance: none;
            background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%239CA3AF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'></polyline></svg>"); /* Custom arrow */
            background-repeat: no-repeat;
            background-position: right 0.75rem center;
            background-size: 1rem;
          }
        `}
      </style>
      <div className="p-5 border-2 border-gray-300 rounded-xl my-5">
        <p className="font-semibold text-gray-600 text-xl underline">
          Product Management Details:
        </p>
        <div className="flex flex-col md:flex-row px-10 mt-4 gap-10">
          {/* Left Column */}
          <div className="w-full">
            <div className="flex flex-col mt-4">
              <label
                htmlFor="productAddedBy"
                className="font-normal text-gray-600 text-lg"
              >
                Product Added By
              </label>
              <input
                type="text"
                id="productAddedBy"
                placeholder="Administrator"
                className="outline-none rounded-lg border border-gray-300 px-4 py-1.5 text-gray-600"
              />
            </div>

            <div className="flex flex-col mt-4">
              <label
                htmlFor="productAddedTime"
                className="font-normal text-gray-600 text-lg"
              >
                Product Added Time
              </label>
              <input
                type="text"
                id="productAddedTime"
                placeholder="13:30"
                className="outline-none rounded-lg border border-gray-300 px-4 py-1.5 text-gray-600"
              />
            </div>

            <div className="flex flex-col mt-4">
              <label
                htmlFor="productLastModifiedDate"
                className="font-normal text-gray-600 text-lg"
              >
                Product Last Modified Date{" "}
                <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="productLastModifiedDate"
                placeholder="12/11/2024"
                className="outline-none rounded-lg border border-gray-300 px-4 py-1.5 text-gray-600"
              />
            </div>

            <div className="flex flex-col mt-4">
              <label
                htmlFor="productOwner"
                className="font-normal text-gray-600 text-lg"
              >
                Product Owner <span className="text-red-500">*</span>
              </label>
              <select
                id="productOwner"
                className="custom-select outline-none rounded-lg border border-gray-300 px-4 py-1.5 text-gray-600"
              >
                <option value="" disabled selected>
                  Select Owner
                </option>
                <option value="owner1">Owner 1</option>
                <option value="owner2">Owner 2</option>
              </select>
            </div>

            <div className="flex flex-col mt-4">
              <label
                htmlFor="productRecommendedFor"
                className="font-normal text-gray-600 text-lg"
              >
                Product Recommended For <span className="text-red-500">*</span>
              </label>
              <select
                id="productRecommendedFor"
                className="custom-select outline-none rounded-lg border border-gray-300 px-4 py-1.5 text-gray-600"
              >
                <option value="" disabled selected>
                  Select Recommended Role
                </option>
                <option value="role1">Role 1</option>
                <option value="role2">Role 2</option>
              </select>
            </div>

            <div className="flex flex-col mt-4">
              <label
                htmlFor="tags"
                className="font-normal text-gray-600 text-lg"
              >
                Tags <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="tags"
                placeholder="Enter Tags"
                className="outline-none rounded-lg border border-gray-300 px-4 py-1.5 text-gray-600"
              />
            </div>
          </div>

          {/* Right Column */}
          <div className="w-full">
            <div className="flex flex-col mt-4">
              <label
                htmlFor="productAddedDate"
                className="font-normal text-gray-600 text-lg"
              >
                Product Added Date
              </label>
              <input
                type="text"
                id="productAddedDate"
                placeholder="12/11/2024"
                className="outline-none rounded-lg border border-gray-300 px-4 py-1.5 text-gray-600"
              />
            </div>

            <div className="flex flex-col mt-4">
              <label
                htmlFor="productLastModifiedBy"
                className="font-normal text-gray-600 text-lg"
              >
                Product Last Modified By
              </label>
              <input
                type="text"
                id="productLastModifiedBy"
                placeholder="Administrator"
                className="outline-none rounded-lg border border-gray-300 px-4 py-1.5 text-gray-600"
              />
            </div>

            <div className="flex flex-col mt-4">
              <label
                htmlFor="productLastModifiedTime"
                className="font-normal text-gray-600 text-lg"
              >
                Product Last Modified Time{" "}
                <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="productLastModifiedTime"
                placeholder="13:30"
                className="outline-none rounded-lg border border-gray-300 px-4 py-1.5 text-gray-600"
              />
            </div>

            <div className="flex flex-col mt-4">
              <label
                htmlFor="nextStep"
                className="font-normal text-gray-600 text-lg"
              >
                Next Step <span className="text-red-500">*</span>
              </label>
              <select
                id="nextStep"
                className="custom-select outline-none rounded-lg border border-gray-300 px-4 py-1.5 text-gray-600"
              >
                <option value="" disabled selected>
                  Select Next Step
                </option>
                <option value="step1">Step 1</option>
                <option value="step2">Step 2</option>
              </select>
            </div>

            <div
              className="flex flex-col mt-4 cursor-pointer"
              onClick={() => setOpenAssignModal(true)}
            >
              <label
                htmlFor="assignedTo"
                className="font-normal text-gray-600 text-lg mb-1"
              >
                Assigned To <span className="text-red-500">*</span>
              </label>

              <div className="relative">
                <input
                  type="text"
                  id="assignedTo"
                  placeholder="Selected To"
                  className="outline-none cursor-pointer rounded-lg border border-gray-300 px-4 py-1.5 pr-10 w-full text-gray-600"
                  readOnly
                />
                <TbCaretUpDownFilled className="absolute cursor-pointer right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none" />
              </div>
            </div>
          </div>
        </div>
        {openAssignModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 px-2">
            <div className="bg-white w-1/2 h-screen p-6 rounded-xl relative overflow-y-auto max-h-screen">
              {/* Close Button */}
              <button
                className="absolute top-3 right-3 text-xl font-bold"
                onClick={() => setOpenAssignModal(false)}
              >
                ✕
              </button>

              <h2 className="text-xl font-bold mb-4">Assigned To</h2>

              <div className="flex items-center gap-2 mb-4">
                <input type="checkbox" id="assignToMe" />
                <label htmlFor="assignToMe">Assign to me</label>
              </div>

              <div className="mb-3">
                <label className="font-medium">Assign To *</label>
                <input
                  className="w-full outline-none border border-gray-300 px-4 py-2 rounded mt-1"
                  placeholder="Enter assign to"
                />
              </div>

              <div className="flex gap-4 mb-3 flex-col sm:flex-row">
                <div className="flex-1">
                  <label className="font-medium">Completed By</label>
                  <input
                    type="date"
                    className="w-full outline-none border border-gray-300 px-4 py-2 rounded mt-1"
                  />
                </div>
                <div className="flex-1">
                  <label className="font-medium outline-none">Priority</label>
                  <select className="w-full border border-gray-300 px-4 py-2 rounded mt-1">
                    <option>Select priority</option>
                    <option>High</option>
                    <option>Medium</option>
                    <option>Low</option>
                  </select>
                </div>
              </div>

              <div className="mb-4">
                <label className="font-medium">Comments</label>
                <textarea
                  className="w-full border outline-none border-gray-300 px-4 py-2 h-52 rounded mt-1"
                  rows="3"
                  placeholder="Write..."
                />
              </div>

              <div className="text-right">
                <button
                  onClick={() => {
                    setOpenAssignModal(false);
                    setShowSuccessPopup(true);
                  }}
                  className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
                >
                  Assign
                </button>
              </div>
            </div>
          </div>
        )}

        {showSuccessPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg text-center shadow-lg">
              <div className="text-4xl text-red-600 mb-2">✅</div>
              <p className="text-lg font-semibold text-gray-700 mb-4">
                Buyer Assigned Successfully!!! ✅
              </p>
              <button
                onClick={() => setShowSuccessPopup(false)}
                className="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-6 rounded"
              >
                Done
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Product_Management_Details;
